import axios from 'axios';
import Chart from 'chart.js/auto';
import { api } from './utils';
import { deleteCookieOnAllDomains, inIframe, isJSON } from '../utils';

export function orgSearch(data: any, callback: any): any {
  const url = `${getIBLSEARCHURL()}/api/search/search/${data}`;
  axios
    .get(url)
    .then((response) => {
      // Handle successful response
      callback(response.data);
    })
    .catch((error) => {
      // Handle error
      console.error(error);
    });
}

export function getSkillDescription(skillLevel: number) {
  switch (skillLevel) {
    case 1:
      return 'Can complete narrow and limited tasks requiring basic skills with direct supervision or guidance.';
    case 2:
      return 'Handles routine assignments with some confidence; occasional assistance may be needed.';
    case 3:
      return 'Capable of managing varied tasks; understands nuances but may seek guidance for complexities.';
    case 4:
      return 'Skilled at handling complex scenarios; regularly assists and mentors others in the domain.';
    case 5:
      return 'Demonstrates mastery in tasks, often pioneering solutions; consistently leads by example.';
    default:
      return ''; // Handle invalid skill levels
  }
}

export function getUserId() {
  const userData = JSON.parse((localStorage as any).getItem('userData'));
  return userData.user_id;
}

export function getUserName() {
  const userData = isJSON((localStorage as any).getItem('userData'))
    ? JSON.parse((localStorage as any).getItem('userData'))
    : null;
  return userData ? userData?.user_nicename : null;
}

export function getTenant() {
  // return "main"
  return localStorage.getItem('tenant');
}

export function getParameterByName(name: string, url?: string) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  let parameterValue = decodeURIComponent(results[2].replace(/\+/g, ' '));
  parameterValue = parameterValue.replace(/ /g, '+'); // Replace spaces with "+"
  return parameterValue;
}

export function credentialImageURL(credential: any) {
  return (
    credential?.credentialDetails?.iconImage || '/images/default_badge.png'
  );
}

export function getRandomImage() {
  const img_url = '/images/courses/';
  const images_array = [
    'c1s.jpeg',
    'c2s.jpeg',
    'c3s.jpeg',
    'c4s.jpeg',
    'c5s.jpeg',
    'c6s.jpeg',
    'c7s.jpeg',
    'c8s.jpeg',
  ];
  const random = Math.floor(Math.random() * images_array.length);
  return img_url + images_array[random];
}

export function secondsToHoursAndMinutes(_seconds: number) {
  const hours = Math.floor(_seconds / 3600);
  const minutes = Math.floor((_seconds % 3600) / 60);
  const seconds = _seconds % 60;

  const formattedHours = hours < 10 ? `0${hours}` : hours;
  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

  return `${formattedHours}:${formattedMinutes}`;
}

export function formatReadableDate(inputDate: string) {
  // Function to check if the input date string has timezone information
  function hasTimezoneInfo(dateString: string): boolean {
    // Regex to match timezone offset (e.g., +02:00, -0400, Z)
    const timezoneRegex = /([+-]\d{2}:\d{2}|[+-]\d{4}|Z)$/;
    return timezoneRegex.test(dateString);
  }

  // Parse the input date string and convert to UTC
  let dateObj: Date;
  if (hasTimezoneInfo(inputDate)) {
    dateObj = new Date(inputDate);
  } else {
    dateObj = new Date(`${inputDate}Z`); // Treat as UTC if no timezone info
  }

  // Check if the date is valid
  if (isNaN(dateObj.getTime())) {
    return NaN;
  }

  // Convert the date to a UTC string
  const utcDateString = dateObj.toISOString();

  // Create a new Date object using the UTC string
  const utcDateObj = new Date(utcDateString);

  // Define options for formatting
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'UTC' // Force UTC timezone
  };

  // Format the date using the appropriate locale and timezone
  return utcDateObj.toLocaleDateString(undefined, options);
}


// TODO : add process.env
export function getIBLSEARCHURL() {
  return process.env.REACT_APP_IBL_SEARCH_URL;
}

export function getYearDateRange() {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth();

  const startMonth = (currentMonth + 12) % 12;
  const endMonth = currentMonth;
  const yearOffset = Math.floor((currentMonth - 12) / 12);
  const startYear = currentYear + yearOffset;

  const startDate = new Date(startYear, startMonth, 1);
  const endDate = new Date(currentYear, endMonth + 1, 0);

  return {
    start: startDate.toISOString().split('T')[0],
    end: endDate.toISOString().split('T')[0],
  };
}

export function formatEarnedOnDate(stringDate: string) {
  const options: Intl.DateTimeFormatOptions = {
    day: 'numeric',
    year: 'numeric',
    month: 'short',
  };
  const date = new Date(stringDate);
  return date.toLocaleDateString('en-US', options);
}

export function getImageUrl(url: string) {
  const urlRegex = /^(ftp|http|https):\/\/[^ "]+$/;

  if (urlRegex.test(url)) {
    return url;
  }

  return '/images/default_avatar.png';
}

export function parseLocalStorageData(key: string) {
  const jsonString = localStorage.getItem(key);

  if (!jsonString) {
    console.error(`No data found in localStorage for key: ${key}`);
    return null;
  }

  try {
    const parsedData = JSON.parse(jsonString);
    return parsedData;
  } catch (error) {
    console.error(`Error parsing JSON data for key: ${key}`, error);
    return null;
  }
}

export function parseJwt(token: string) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join('')
  );

  return JSON.parse(jsonPayload);
}

export function jwtIsValid(token: string) {
  if (!token) return false;

  let valid = false;
  try {
    const parsedToken = parseJwt(token);
    if (parsedToken?.exp) {
      valid = parsedToken.exp * 1000 > new Date().getTime();
    }
    return valid;
  } catch (error) {
    return false;
  }
}

export const GLOBAL_COLORS = {
  grey: process.env.REACT_APP_GREY_COLOR,
  font: process.env.REACT_APP_FONT_COLOR,
  icon_color: process.env.REACT_APP_ICON_COLOR,
  primary: process.env.REACT_APP_PRIMARY_COLOR,
  secondary: process.env.REACT_APP_SECONDARY_COLOR,
  tertiary: process.env.REACT_APP_TERTIARY_COLOR,
  grey_secondary: process.env.REACT_APP_GREY_SECONDARY_COLOR,
  white_smoke: process.env.REACT_APP_WHITE_SMOKE_COLOR,
};

export const fillUpLearningHoursGraph = (daysTotal, chartRef) => {
  const xValues = [];
  const yValues = [];
  for (const date in daysTotal) {
    if (daysTotal.hasOwnProperty(date)) {
      const dayName = new Date(date).toLocaleString('en-us', {
        weekday: 'short',
      });

      const [year, month, day] = date.split('-');
      const formattedDate = `${dayName} ${parseInt(month)}/${parseInt(day)}/${year.slice(-2)}`;
      xValues.push(formattedDate);
      yValues.push((daysTotal[date] / 60).toFixed(0));
    }
  }

  const barColors = Array(xValues.length).fill('rgba(104, 169, 222, 0.61)');

  const ctx: any = document.getElementById('learningHoursGraph');
  chartRef.current = new Chart(ctx, {
    type: 'bar',
    data: {
      labels: xValues,
      datasets: [
        {
          backgroundColor: barColors,
          data: yValues,
          label: 'Minutes',
        },
      ],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        y: {
          beginAtZero: true,
          title: {
            display: true,
            text: 'Minutes',
          },
        },
      },
      plugins: {
        legend: {
          display: true,
        },
      },
    },
  });
};

export function getParentDomain(domain) {
  if (!domain) {
    return '';
  }
  const parts = domain.split('.');
  return parts.length > 1 ? `.${parts.slice(-2).join('.')}` : domain;
}

export function clearCookies() {
  // Clear cookies
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i];
    const eqPos = cookie.indexOf('=');
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    deleteCookieOnAllDomains(name, window.location.hostname);
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;Domain=${getParentDomain(
      window.location.hostname
    )}`;
  }
}

export const handleLogout = (redirectUrl = window.location.origin) => {
  localStorage.clear();
  clearCookies();
  window.location.href = `${process.env.REACT_APP_IBL_SPA_AUTH_URL}/logout?redirect-to=${redirectUrl}`;
};


export function secondsToDaysHoursAndMinutes(_seconds) {
  const days = Math.floor(_seconds / 86400); // 86400 seconds in a day
  const hours = Math.floor((_seconds % 86400) / 3600);
  const minutes = Math.floor((_seconds % 3600) / 60);
  const seconds = _seconds % 60;

  const formattedHours = hours < 10 ? `0${hours}` : hours;
  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

  return `${days > 0 ? `${days} day${days > 1 ? 's' : ''}, ` : ''}${formattedHours}:${formattedMinutes}`;
}


const PERCENTILE_IMAGE_MAP = {
  Beginner: '/images/skillLeaderBoard/beginner.png',
  Novice: '/images/skillLeaderBoard/novice.png',
  Intermediate: '/images/skillLeaderBoard/intermediate.png',
  Advanced: '/images/skillLeaderBoard/advanced.png',
  Expert: '/images/skillLeaderBoard/expert.png',
  Zero: '/images/skillLeaderBoard/zero.png',
  ExpertAdvanced: '/images/skillLeaderBoard/expert-advanced.png',
};

const SCORE_STYLING_MAP = {
  Beginner: {
    left: '-22px',
    top: '132px',
  },
  Novice: {
    left: '-22px',
    top: '110px',
  },
  Intermediate: {
    left: '-22px',
    top: '95px',
  },
  Advanced: {
    left: '-22px',
    top: '80px',
  },
  Expert: {
    left: '-22px',
    top: '65px',
  },
  Zero: {
    left: '-22px',
    top: '150px',
  },
  ExpertAdvanced: {
    left: '-22px',
    top: '20px',
  },
};

const MAX_SKILL_POINT = process.env.REACT_APP_IBL_MAX_SKILL_POINT ? parseInt(process.env.REACT_APP_IBL_MAX_SKILL_POINT, 10) : 500;

export function getUserLevel(percentile : number) {
  if (percentile === null || percentile === undefined || percentile === 0) {
    return 'Zero';
  }

  const beginnerThreshold = (MAX_SKILL_POINT * 20) / 100;
  const noviceThreshold = (MAX_SKILL_POINT * 40) / 100;
  const intermediateThreshold = (MAX_SKILL_POINT * 60) / 100;
  const advancedThreshold = (MAX_SKILL_POINT * 80) / 100;
  const expertThreshold = (MAX_SKILL_POINT * 90) / 100;

  if (percentile <= beginnerThreshold) {
    return 'Beginner';
  } else if (percentile <= noviceThreshold) {
    return 'Novice';
  } else if (percentile <= intermediateThreshold) {
    return 'Intermediate';
  } else if (percentile <= advancedThreshold) {
    return 'Advanced';
  } else if (percentile <= expertThreshold) {
    return 'Expert';
  } else {
    return 'ExpertAdvanced';
  }
}

export function getPercentileImage(percentile :number) {
  return PERCENTILE_IMAGE_MAP[getUserLevel(percentile)];
}

export function getScoreStyling(percentile : number) {
  return SCORE_STYLING_MAP[getUserLevel(percentile)];
}

export const getNoSkillMessage = (skillType:string, username : string) => {
  return !inIframe() ? `You don't have any ${skillType} skills yet.` : `${username} doesn't have any ${skillType} skills yet.`
}

export const isAdmin = () => {
  try {
    const userData = JSON.parse(localStorage.getItem('current_tenant'));
    return userData?.is_admin || false;
  } catch (error) {
    console.error('Error parsing user data:', error);
    return false;
  }
};
